import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";

export default class PageTeamTodos
{
    constructor(targetElement)
    {
        const teamId = targetElement.dataset.teamid;

        const todoEle = ele.byId("todos");
        const searchParams = new URLSearchParams(window.location.search);

        const apiParams = new URLSearchParams();
        if (searchParams.has("type")) apiParams.set("type", searchParams.get("type"));
        if (searchParams.has("category")) apiParams.set("category", searchParams.get("category"));
        let apiUrl = "teams/" + teamId + "/todos";
        if (apiParams.size > 0) apiUrl += "?" + apiParams;

        api.get(apiUrl, (res) =>
        {
            web.setHandleBarHtml("todos", res.data, todoEle);
            const tabs = todoEle.querySelectorAll("ul.tab-bar li");
            tabs.forEach((tab) =>
            {
                tab.addEventListener("activated", (e) =>
                {
                    const table = ele.byId(tab.dataset.tabName);
                    if (table)
                    {
                        const todos = table.querySelectorAll("tr.todo");
                        const numEle = ele.byId("num_todos");
                        if (numEle) numEle.innerText = todos.length;
                    }
                });
            });
            web.tabs.initTabs(tabs);
            web.tables.initTables(todoEle.querySelectorAll("table.sortable"));
        });
    }
}
